/**
 * constants/fieldTypes.ts
 *
 * Shared field type options for the SmartTable form creation workflow.
 * Extracted from SmartTableRow.tsx so SmartTableCard and SmartTableImportModal
 * can import from a single source of truth without depending on the legacy
 * SmartTableRow module.
 *
 * Created April 2026: extracted as part of SmartTable modularisation.
 * Updated April 2026: FIELD_TYPE_LABELS uses Record<FieldType, string> so TypeScript
 *   enforces exhaustive coverage at compile time when FieldType gains new members.
 *   FIELD_TYPE_OPTIONS is derived from Object.entries(FIELD_TYPE_LABELS) so both
 *   the type-safe mapping and the iterable array are always in sync.
 */

import type { FieldType } from '../types/database';

export interface FieldTypeOption {
  value: FieldType;
  label: string;
}

const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  document: 'Document',
  short_text: 'Texte court',
  text: 'Texte long',
  date: 'Date',
  single_choice: 'Choix unique',
  multiple_choice: 'Choix multiple',
  info: 'Message informatif',
};

export const FIELD_TYPE_OPTIONS: FieldTypeOption[] = (
  Object.entries(FIELD_TYPE_LABELS) as [FieldType, string][]
).map(([value, label]) => ({ value, label }));
